import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Badge from "../Badge/Badge.js";
import Button from "../Button/Button.js";
import Icon from "../Icon/Icon.js";
import './Header.css';/* empty css            */
const HeaderParametersToggler = ({
  show,
  onToggle,
  showLabel,
  hideLabel,
  optionsLabel,
  withCounter = false,
  count = 0
}) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classnames([
        "perxis-auto-header-parameters-toggler",
        {
          "perxis-auto-header-parameters-toggler--open": show
        }
      ]),
      children: /* @__PURE__ */ jsxs(
        Button,
        {
          type: "text",
          icon: /* @__PURE__ */ jsx(Icon, { name: "filters" }),
          iconPosition: "left",
          onClick: onToggle,
          className: classnames("perxis-auto-header-parameters-toggler__button"),
          children: [
            /* @__PURE__ */ jsxs("span", { className: classnames("perxis-auto-header-parameters-toggler__button-text"), children: [
              show ? hideLabel : showLabel,
              " ",
              !!optionsLabel && /* @__PURE__ */ jsx("span", { className: classnames("perxis-auto-header-parameters-toggler__button-add-text"), children: optionsLabel })
            ] }),
            withCounter && /* @__PURE__ */ jsx(Badge, { count, type: "secondary", className: classnames("perxis-auto-header-parameters-toggler__badge") })
          ]
        }
      )
    }
  );
};
export {
  HeaderParametersToggler as default
};
//# sourceMappingURL=HeaderParametersToggler.js.map
